import type { AxiosError } from "axios";
import { Request, Response, Middleware } from "../common";

interface IAxiosLikeErrorMiddleware {
  handleNotOkStatusCode: (error: Error, response: Response) => void;
}

export class AxiosLikeErrorMiddleware implements Middleware {
  constructor(private readonly config: IAxiosLikeErrorMiddleware) { }

  async onRequest(request: Request, next: () => Promise<Response>): Promise<Response> {
    const response = await next();

    if (response.statusCode >= 200 && response.statusCode < 300) {
      return response;
    }

    const error = new Error(`Request to ${request.url} failed with status code ${response.statusCode}`);

    this.config.handleNotOkStatusCode(error, response);

    const axiosLikeError: AxiosError = {
      response: {
        data: response.body,
        status: response.statusCode,
        statusText: response.statusCode.toString(),
        headers: response.headers ?? {},
        config: {} as any,
      },
      name: "AxiosError",
      message: response.body.message ?? response.body.error ?? error,
      isAxiosError: true,
      config: {} as any,
      toJSON: () => {
        return axiosLikeError;
      },
    };

    return Promise.reject(axiosLikeError);
  }
}
